<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="aesops-warning">
<h1>Aesop’s Warning</h1>
<p>It was the sour light reflecting the sunset that drew the little girl to the jigsaw. The colours in the puzzle were odd somehow – they attracted her but at the same time repulsed her. A tingle of excitement unrolled itself over her shoulders and ran down her spine.</p>
<p>The scene depicted was a rural one; fields, trees, grazing sheep. Just off centre was a stand of dark conifers which seemed to loom hugely out of the picture. All the other jigsaws on the shelves showed scenes which were either of a tedious monotony or saccharine sweetness.</p>
<p>The girl had to own the puzzle.</p>
<p>She tried to reach up and pull the box down from the shelf but it suddenly seemed to be higher up than it had been. ‘Grandfather, please could I have that one?’ she asked.</p>
<p>He stared at her intently and said, ‘Perhaps it doesn’t want to be owned by you.’ He had never looked at her that way before and she shivered slightly.</p>
<p>‘But I must have it!’</p>
<p>The old man shook his head and lifted down the box.</p>
<p>Later, in her bedroom, the girl opened up the box, locating and setting out the edges of the puzzle. After a time, the image began to throb and waver with colours that became increasingly more acidic. Slowly she discovered that she could only sit at the table for a short time before her temples started to throb.</p>
<p>Once, when the girl was out, the grandfather came into her room to see how the puzzle was progressing. As soon as he entered he felt uneasy. The room seemed to adjust itself suddenly, as if gravity had shifted. He noticed an unpleasant sour taste in his mouth. The stand of conifers in the middle distance had become darker and larger and as he turned away he thought he saw a slight movement in the trees.</p>
<p>Heart thumping, the old man turned back towards the jigsaw. A white face quickly withdrew into the gloom.</p>
<p>He rubbed his eyes, putting the vision down to a trick of the light.</p>
<p>The old man said nothing to his granddaughter, hoping that her fascination with the puzzle would fade when she’d completed it. However she spent increasing amounts of time in her room, eating little and growing even more pale. One night he heard her screaming and when he went to her, she seemed to be pushing something away from her in bed and shouting, ‘Get away!’</p>
<p>On the day that the little girl finished the jigsaw, a deep aching silence had settled in the house. When her grandfather entered the room he was horrified to see that her face was bone white and her irises the colour of pitch. She smiled weakly. ‘How does the jigsaw look?’ He glanced across to the table.</p>
<p>The picture was completely black, like her eyes.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?4db92aa4